module.exports = __webpack_public_path__ + "static/img/b1_footer.35ab59b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/childrens/b1_footer.png
// module id = po+u
// module chunks = 1